module.exports = __webpack_public_path__ + "static/media/redFlag.52dc0902.svg";